import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PlansService} from './services/plans.service';
import {UsersService} from './services/users.service';
import {CustomersService} from './services/customers.service';
import {CategoriesService} from './services/categories.service';
import {AuthService} from './services/auth.service';
import {AuthGuardService} from './services/auth-guard';
import {ResourcesLoaderService} from './services/resources-loader.service';
import {SubscriptionsService} from './services/subscriptions.service';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {JwtService} from './services/jwt.service';
import {ApiService} from './services/api.service';
import {UserService} from './services/user.service';
import {HttpTokenInterceptor} from './interceptors';
import {AuthGuestGuardService} from './services/auth-guest-guard.service';
import {PaymentsService} from './services/payments.service';
import {NotificationsService} from './services/notifications.service';
import {ReportService} from './services/report.service';
import {InsuranceService} from './services/insurance.service';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
  ],
  declarations: [],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true},
    AuthGuardService,
    AuthGuestGuardService,
    ResourcesLoaderService,
    CategoriesService,
    PlansService,
    CustomersService,
    UsersService,
    AuthService,
    SubscriptionsService,
    // ...
    JwtService,
    ApiService,
    UserService,
    PaymentsService,
    ReportService,
    InsuranceService,
    NotificationsService
  ]
})
export class CoreModule {
}
